/**
 * Environment-gated logger utility
 *
 * In production builds, all logging is suppressed.
 * In development, logs are forwarded to the browser console.
 */

const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  log: (...args: unknown[]): void => {
    if (isDev) {
      console.log(...args);
    }
  },

  error: (...args: unknown[]): void => {
    if (isDev) {
      console.error(...args);
    }
  },

  warn: (...args: unknown[]): void => {
    if (isDev) {
      console.warn(...args);
    }
  },

  info: (...args: unknown[]): void => {
    if (isDev) {
      console.info(...args);
    }
  },

  debug: (...args: unknown[]): void => {
    if (isDev) {
      console.debug(...args);
    }
  },
};

export default logger;
